import { IFavoriteParams } from '../types/actionParams';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class AddFavoriteRequest extends Request<IFavoriteParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('addFavorite', params);
  }
}
